import { render } from "./gameHome.vue?vue&type=template&id=0a39f4fc"
import script from "./gameHome.vue?vue&type=script&lang=js"
export * from "./gameHome.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zekarim/Documents/HEIG/roesti-quiz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__